import React, { useState, useRef } from 'react';
import { Plus, X } from 'lucide-react';

const AddColumnButton = ({ onAddColumn }) => {
  const [isAdding, setIsAdding] = useState(false);
  const [columnName, setColumnName] = useState('');
  const inputRef = useRef(null);

  const handleClick = () => {
    setIsAdding(true);
    setColumnName('');
    setTimeout(() => inputRef.current && inputRef.current.focus(), 50);
  };

  const handleConfirm = () => {
    const name = columnName.trim();
    if (name) {
      onAddColumn(name);
    }
    setIsAdding(false);
    setColumnName('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleConfirm();
    if (e.key === 'Escape') {
      setIsAdding(false);
      setColumnName('');
    }
  };

  if (isAdding) {
    return (
      <div className="w-[220px] flex-shrink-0 bg-white rounded-xl shadow-sm border border-blue-200 p-3">
        <input
          ref={inputRef}
          type="text"
          value={columnName}
          onChange={(e) => setColumnName(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Column name..."
          className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 mb-2"
        />
        <div className="flex gap-1">
          <button
            onClick={handleConfirm}
            className="flex-1 py-1.5 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center justify-center gap-1"
          >
            <Plus size={14} />
            Add
          </button>
          <button
            onClick={() => { setIsAdding(false); setColumnName(''); }}
            className="p-1.5 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100"
          >
            <X size={14} />
          </button>
        </div>
      </div>
    );
  }

  return (
    <button
      onClick={handleClick}
      className="w-[54px] flex-shrink-0 h-16 bg-white bg-opacity-60 rounded-xl border border-dashed border-gray-300
        flex flex-col items-center justify-center text-gray-400 hover:text-blue-500 hover:border-blue-300
        hover:bg-blue-50 transition-colors self-start"
    >
      <Plus size={20} />
    </button>
  );
};

export default AddColumnButton;
